module.exports = __webpack_public_path__ + "img/Star.c35a18e7.svg";